import SetupBuddy from "../../../../src/courses/partials/responsible-development/deploying-from-version-control/buddy.mdx";
import * as React from 'react';
export default {
  SetupBuddy,
  React
};